/**
 * Generate a display name from first and last name.
 * Format: First Name + Last Initial (e.g., "Sarah C.")
 * 
 * @param firstName - User's first name
 * @param lastName - User's last name
 * @param fallbackName - Optional fallback if first/last not available
 * @returns Display name string
 */
export function generateDisplayName(
  firstName?: string | null,
  lastName?: string | null,
  fallbackName?: string | null
): string {
  if (firstName && lastName) {
    const lastInitial = lastName.charAt(0).toUpperCase();
    return `${firstName} ${lastInitial}.`;
  }
  
  if (firstName) {
    return firstName;
  }
  
  if (fallbackName) {
    // Try to parse full name into first name + last initial
    const parts = fallbackName.trim().split(/\s+/);
    if (parts.length >= 2) {
      const first = parts[0];
      const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
      return `${first} ${lastInitial}.`;
    }
    return fallbackName;
  }
  
  return 'User';
}

/**
 * Get initials from a name for avatar fallback.
 * 
 * @param firstName - User's first name
 * @param lastName - User's last name
 * @param fallbackName - Optional fallback if first/last not available
 * @returns 1-2 character initials
 */
export function getAvatarInitials(
  firstName?: string | null,
  lastName?: string | null,
  fallbackName?: string | null
): string {
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }
  
  if (firstName) {
    return firstName.charAt(0).toUpperCase();
  }
  
  if (fallbackName) {
    const parts = fallbackName.trim().split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
    }
    return fallbackName.charAt(0).toUpperCase();
  }
  
  return 'U';
}
